export enum Constants {
  DELETE_AUDIENCE_VIEW_REACTIONS = "app/broadcast/AUDIENCE_VIEW/DELETE_AUDIENCE_VIEW_REACTIONS",
  INSERT_REACTED_USER = "app/broadcast/AUDIENCE_VIEW/INSERT_REACTED_USER",
  RESET_AUDIENCE_VIEW_STATE = "app/broadcast/AUDIENCE_VIEW/RESET_AUDIENCE_VIEW_STATE",
  SET_IS_CONTAINER_MOUNTED = "app/broadcast/AUDIENCE_VIEW/SET_IS_CONTAINER_MOUNTED",
  SET_ITEMS_PER_ROW = "app/broadcast/AUDIENCE_VIEW/SET_ITEMS_PER_ROW",
  TOGGLE_EXPAND = "app/broadcast/AUDIENCE_VIEW/TOGGLE_EXPAND",
  UPDATE_SLOTS = "app/broadcast/AUDIENCE_VIEW/UPDATE_SLOTS",
}

const TRANSITION_1_DURATION = 600;
const ANIMATION_1_DURATION = 8000;
const TRANSITION_2_DURATION = 600;

export const ANIMATION_DURATION =
  TRANSITION_1_DURATION + ANIMATION_1_DURATION + TRANSITION_2_DURATION;
